// The rest stop of the telephone sheet. The stylesheet states the same
// height as the `max-height` of `#dock`, and both take the one figure of
// `data/presentation/presentation.toml` (R1371), so the drag snaps to the
// height the sheet rests at.

import { CHROME_SHEET_REST_VH } from '../../gen/presentation';

/** The rest height of the sheet, in px, for a viewport `vh` px tall. */
export const sheetRestPx = (vh: number): number => Math.round((vh * CHROME_SHEET_REST_VH) / 100);

/** The top and the foot of a box on the screen, in one unit. */
export interface Span { top: number; bottom: number }

/**
 * The scroll of a view that shows `row` whole, from `scrollTop`: the least
 * travel, which stands the row's foot at the view's foot. A row taller
 * than the view shows its top. A row in view already keeps the scroll.
 * WAR · SOVEREIGNTY brings the timelapse transport over the queue strip
 * with it while a frame stands on the map (ui-map-interface.md §3.6,
 * R1620).
 */
export function revealScroll(view: Span, row: Span, scrollTop: number): number {
  if (row.bottom > view.bottom) return scrollTop + Math.min(row.bottom - view.bottom, row.top - view.top);
  if (row.top < view.top) return scrollTop - (view.top - row.top);
  return scrollTop;
}
